import React, { useState } from 'react'
// @ts-ignore no types
import { Text, hooks } from '@adc/ui-adc'

// Constants for text limits
const DEFAULT_MAX_VISIBLE_CHARACTERS = 140
const COLLAPSE_SUFFIX_LENGTH = 3
const EXPAND_LABEL_EXTRA_SPACE = 10

interface SpecialNotesProps {
  notes: string
  hideTitle?: boolean
  maxVisibleCharacters?: number
}

const SpecialNotes = ({
  notes,
  hideTitle = false,
  maxVisibleCharacters = DEFAULT_MAX_VISIBLE_CHARACTERS,
}: SpecialNotesProps) => {
  const [collapsed, setCollapsed] = useState(true)
  const toggleCollapse = () => setCollapsed(!collapsed)
  const isMobile = hooks.useIsMobileHook()

  if (!notes) return null

  const titleSize = isMobile ? 'big' : 'huge'
  const maxCollapseSize = maxVisibleCharacters - COLLAPSE_SUFFIX_LENGTH
  const textSizeLimit = maxCollapseSize + EXPAND_LABEL_EXTRA_SPACE

  return (
    <div>
      {!hideTitle && (
        <Text
          as='p'
          size={titleSize}
          weight='medium'
          data-elm-id='mls_comment_label'
        >
          Special Notes
        </Text>
      )}

      <Text as='p' color='gray' data-elm-id='mls_comment_value'>
        {notes.length < textSizeLimit ? (
          notes
        ) : (
          <span>
            {collapsed ? `${notes.substring(0, maxCollapseSize)}...` : notes}{' '}
            <a onClick={toggleCollapse}>
              {collapsed ? 'More \u00BB' : '\u00AB Less'}
            </a>
          </span>
        )}
      </Text>
    </div>
  )
}

export default SpecialNotes
